import { ActionBar, ButtonVariant, FormRouteLeavingPrompt, StyledMaxWidth } from '@dreryk/react-components';

import { noop } from '~libs.typescript';

import { prescriptionVisitTemplatesTranslationKeys } from '../translations';

import { PrescriptionVisitTemplatesForm } from './PrescriptionVisitTemplatesForm';
import { PrescriptionVisitTemplatesLoader } from './PrescriptionVisitTemplates.loader';
import { PrescriptionVisitTemplatesSaveActionInterceptor } from './PrescriptionVisitTemplatesSaveActionInterceptor';
import { formInitializer } from './PrescriptionVisitTemplatesForm.utils';

export const PrescriptionVisitTemplates = (): JSX.Element => {
   return (
      <ActionBar id={'prescription-visit-templates-action-bar'} testId={'prescriptionVisitTemplates'}>
         <PrescriptionVisitTemplatesLoader>
            {(data) => (
               <StyledMaxWidth maxWidth={'800px'}>
                  <PrescriptionVisitTemplatesForm
                     initializer={formInitializer(data)}
                     receptionServices={data.receptionServices}
                     medicalServices={data.medicalServices}
                  >
                     {({ handleSubmit, formState }) => (
                        <>
                           <PrescriptionVisitTemplatesSaveActionInterceptor handleSubmit={handleSubmit}>
                              <ActionBar.PrimaryButton
                                 testId={'prescriptionVisitTemplatesSave'}
                                 label={prescriptionVisitTemplatesTranslationKeys.save}
                                 onClick={noop}
                                 variant={ButtonVariant.PRIMARY}
                              />
                           </PrescriptionVisitTemplatesSaveActionInterceptor>
                           <FormRouteLeavingPrompt formState={formState} />
                        </>
                     )}
                  </PrescriptionVisitTemplatesForm>
               </StyledMaxWidth>
            )}
         </PrescriptionVisitTemplatesLoader>
      </ActionBar>
   );
};
